<template>
    <div class="cookies-eu-banner hidden">
        This website uses <a href="/privacypolicy">cookies.</a>
        <button>Allow cookies</button>
    </div>
</template>
<script>
export default {
    data(){
        return {
            text: "Vue3 component."
        }
    },
    mounted(){
        // https://monsterlessons-academy.com/posts/cookie-consent-popup-cookie-banner-examples-with-html-css-javascript

        const $cookiesBanner = document.querySelector(".cookies-eu-banner");
        const $cookiesBannerButton = $cookiesBanner.querySelector("button");
        const cookieName = "cookiesBanner";
        const hasCookie = this.getCookie(cookieName);

        if (!hasCookie) {
            $cookiesBanner.classList.remove("hidden");
        }

        $cookiesBannerButton.addEventListener("click", () => {
            this.setCookie(cookieName, "accepted");
            $cookiesBanner.classList.add('hiding');
            setTimeout(() => {
                $cookiesBanner.remove();
            }, 1000);
        });
    },
    methods: {
        getCookie(name){
            const value = " " + document.cookie;
            // console.log("value", `==${value}==`);
            const parts = value.split(" " + name + "=");
            return parts.length < 2 ? undefined : parts.pop().split(";").shift();
        },

        setCookie(name, value, expiryDays, domain, path, secure) {
            const exdate = new Date();
            exdate.setHours(
                exdate.getHours() +
                (typeof expiryDays !== "number" ? 365 : expiryDays) * 24
            );
            document.cookie =
                name +
                "=" +
                value +
                ";expires=" +
                exdate.toUTCString() +
                ";path=" +
                (path || "/") +
                (domain ? ";domain=" + domain : "") +
                (secure ? ";secure" : "");
        }
    }
}
</script>
<style lang="scss" scoped>

    .cookies-eu-banner {
        background: #212121;
        color: #fff;
        padding: 9px;
        font-family: "DIN Next LT Pro Regular", Tahoma, Verdana, sans-serif;
        font-size: 13px;
        text-align: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 10;
        border-top: 1px solid #ED1163;
        border-bottom: 1px solid #ED1163;

        transition: all .3s ease;

        a{
            color: white;
            font-family: "DIN Next LT Pro Bold", Tahoma, Verdana, sans-serif;
        }

        &.hiding{
            transform: translateY(100px);
        }

        &.hidden {
            display: none;
        }
    }

    .cookies-eu-banner button {
        text-decoration: none;
        background: black;
        color: #fff;
        cursor: pointer;
        padding: 6px 11px;
        margin: 2px 0;
        font-family: "DIN Next LT Pro Light", Tahoma, Verdana, sans-serif;
        font-size: 13px;
        font-weight: 700;
        transition: all .3s ease;
        margin-left: 14px;
        outline: none;
        border: none;
        border: 1px solid #ED1163;
    }

    .cookies-eu-banner button:hover {
        background: #fff;
        color: #212121;
    }

</style>